import { Box, Modal, Typography, FormControl, Button, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { makeStyles } from '@mui/styles';
import { AddNewDepartmentData } from '../../../network/Department';
import { useAuth } from '../../customContextProviders/AuthContext';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: '30%',
  maxWidth: '35%',
  bgcolor: 'background.paper',
  p: 4,
  borderRadius: 1,
  maxHeight: '90vh',
  overflowY: 'auto'
};

const useStyles = makeStyles((theme) => ({
  menuItem: {
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    minHeight: '20px',
    borderRadius: '8px',
    marginInline: theme.spacing(1)
  }
}));

const addDepartmentSchema = Yup.object().shape({
  name: Yup.string().required('Name is required')
});

export default function AddNewDepartment({
  openAssignedModal,
  handleClose,
  setAlertMetas,
  alertMetas,
  onAction
}) {
  const classes = useStyles();
  const { sessionUserData } = useAuth();
  const orgId = sessionUserData?.user?.organization?.id;
  const userRole = sessionUserData?.user?.userRole?.roleName;

  const addDepartmentFormik = useFormik({
    initialValues: {
      name: '',
      description: ''
    },
    validationSchema: addDepartmentSchema,
    onSubmit: (values, { resetForm }) => {
      addDepartmentFormik.isSubmitting = true;
      AddNewDepartment(values.name, values.description);
      resetForm();
    }
  });

  const { errors, touched, values, handleSubmit, getFieldProps, setFieldValue } =
    addDepartmentFormik;

  const AddNewDepartment = async (name, description) => {
    try {
      const payload = {
        name,
        description,
        organizationId: orgId
      };
      const res = await AddNewDepartmentData(payload);
      if (res) {
        setAlertMetas({
          ...alertMetas,
          severity: 'success',
          snackBarOpened: true,
          msg: 'Department Created Successfully !'
        });
        onAction();
        setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
        handleClose();
      }
    } catch (error) {
      setAlertMetas({
        ...alertMetas,
        severity: 'error',
        snackBarOpened: true,
        msg: error?.response?.data?.message
      });
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
      handleClose();
    }
  };

  return (
    <Box>
      <Modal
        open={openAssignedModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        data-testid="add-new-department"
      >
        <Box sx={style}>
          <Typography sx={{ fontSize: 18, fontWeight: 900 }}>Create New Department</Typography>

          <FormikProvider value={addDepartmentFormik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Box>
                <FormControl fullWidth sx={{ mt: 3 }}>
                  <TextField
                    label="Name"
                    id="name"
                    name="name"
                    variant="outlined"
                    {...getFieldProps('name')}
                    error={Boolean(touched.name && errors.name)}
                    helperText={touched.name && errors.name}
                  />
                </FormControl>
                <FormControl fullWidth sx={{ mt: 3 }}>
                  <TextField
                    label="Description"
                    id="description"
                    name="description"
                    variant="outlined"
                    {...getFieldProps('description')}
                    error={Boolean(touched.description && errors.description)}
                    helperText={touched.description && errors.description}
                  />
                </FormControl>
                <Box sx={{ display: 'flex', float: 'right', flexWrap: 'wrap', mt: 3 }}>
                  <Button variant="contained" sx={{ mr: 2 }} onClick={handleClose}>
                    Cancel
                  </Button>
                  <Button variant="contained" type="submit">
                    Add
                  </Button>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </Box>
      </Modal>
    </Box>
  );
}
